"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const components_1 = require("components");
const config_1 = require("config");
const merchant_portal_reducer_1 = require("merchant-portal-reducer");
const utils_1 = require("utils");
const UploadForm_1 = __importDefault(require("./UploadForm"));
const UploadMsg_1 = __importDefault(require("./UploadMsg"));
const UploadNav_1 = __importDefault(require("./UploadNav"));
const utils_2 = require("./utils");
function DocUpload({ getProposedEnrollmentDataChanges, updateProposedEnrollmentDataChanges, updateProposedEnrollmentFileChanges, pageTitle, displayContinue, makeSyncCallback, locationData, fetchAllLocationsForManager, fetchLocationDetails, currentLocation, }) {
    // Hooks
    const history = (0, react_router_dom_1.useHistory)();
    const { state } = (0, react_router_dom_1.useLocation)();
    /// State
    const [proposedChangeMap, setProposedChangeMap] = (0, react_1.useState)(new Map());
    const [noDocsNeeded, setNoDocsNeeded] = (0, react_1.useState)(null);
    const [displayInfo, setDisplayInfo] = (0, react_1.useState)(null);
    const [localDisplayCont, setLocalDisplayCont] = (0, react_1.useState)(false);
    const [submitting] = (0, react_1.useState)(false);
    const [localResp, setLocalResp] = (0, react_1.useState)(null);
    const [localResp2, setLocalResp2] = (0, react_1.useState)(null);
    const [loadingProposedChanges, setLoadingProposedChanges] = (0, react_1.useState)(true);
    const [returningToDashboard, setReturningToDashboard] = (0, react_1.useState)(false);
    const [displayBasicBtns] = (0, react_1.useState)(false);
    // Funcs
    async function createProposedChangesMap(curData) {
        setLoadingProposedChanges(true);
        const proposedChangeMap = await (0, utils_2.setupChangesMap)(curData, getProposedEnrollmentDataChanges);
        setProposedChangeMap(proposedChangeMap);
        setLoadingProposedChanges(false);
        if (proposedChangeMap.size === 0) {
            setNoDocsNeeded(true);
        }
    }
    const handleReturnToDashboard = (0, react_1.useCallback)(async () => {
        if (pageTitle) {
            history.push((0, config_1.makePath)(config_1.PATH.MERCHANT_PORTAL + config_1.PATH.LOCATION_MANAGEMENT));
        }
        else {
            try {
                setReturningToDashboard(true);
                await fetchAllLocationsForManager();
                await fetchLocationDetails(currentLocation.locationId);
                const goTo = (0, utils_2.getReturnURL)(pageTitle);
                history.push(goTo);
                setReturningToDashboard(false);
            }
            catch {
                setReturningToDashboard(false);
            }
        }
    }, [pageTitle]);
    const handleUploadCallback = ({ store, status, bankResp, fileResp, }) => {
        if (displayContinue) {
            if (status) {
                setLocalResp({
                    store,
                    status,
                    bankResp,
                    fileResp,
                });
                setLocalDisplayCont('continue');
            }
        }
        else {
            if (makeSyncCallback) {
                setLocalResp2({
                    store,
                    status,
                    bankResp,
                    fileResp,
                });
                setLocalDisplayCont('finish');
            }
        }
    };
    async function apiUpdateProposedEnrollmentFileChanges(locationId, proposedChangesRespId) {
        const fileRes = await updateProposedEnrollmentFileChanges(locationId, proposedChangesRespId, {
            file_uuids: [
                ...(localResp2.bankResp?.uuid
                    ? [String(localResp2.bankResp?.uuid)]
                    : []),
                ...(localResp2.fileResp?.uuid
                    ? [String(localResp2.fileResp?.uuid)]
                    : []),
            ],
        });
        return fileRes;
    }
    async function apiSetPendingReview(adsStoreNumber, locationId) {
        const proposedChangesForStore = proposedChangeMap.get(adsStoreNumber);
        try {
            if (locationId) {
                await updateProposedEnrollmentDataChanges(locationId, proposedChangesForStore.changeId, {
                    status: 'pending_review',
                    changes: {
                        change_id: undefined,
                        files: undefined,
                    },
                });
            }
            (0, utils_1.toastSuccess)(`Successfully updated status of changes`, 3000);
        }
        catch (error) {
            (0, utils_1.toastError)(`Failed to update status of changes`, 5000);
        }
    }
    const handleFinishUploadCallback = (0, react_1.useCallback)(async () => {
        const respInfo = {
            // ...(localResp ?? {}),
            ...(localResp2 ?? {}),
        };
        const adsStoreNumber = respInfo.store.storeNumber; //proposedChangeMap.keys().next().value
        const currentStore = currentData
            .filter((itm) => itm.adsStoreNumber === adsStoreNumber)
            .at(0);
        const locationId = currentStore?.locationId;
        const proposedChangesForStore = proposedChangeMap.get(adsStoreNumber);
        // Patch Proposed Changes File UUIDS
        try {
            if (localResp2 &&
                locationId &&
                proposedChangesForStore &&
                proposedChangesForStore.changeId) {
                const fileRes = await apiUpdateProposedEnrollmentFileChanges(locationId, proposedChangesForStore.changeId);
                // Patch Proposed Changes Status
                if (locationId && fileRes) {
                    await apiSetPendingReview(adsStoreNumber, locationId);
                }
                // Reload location data
                if (locationId) {
                    await getProposedEnrollmentDataChanges(locationId);
                }
            }
        }
        catch (error) {
            (0, utils_1.toastError)(`Failed to sync files and changes`, 5000);
        }
    }, [localResp2]);
    const handleContinueCallback = (0, react_1.useCallback)(async () => {
        const locationId = locationData?.[0]?.locationId;
        const adsStoreNumber = locationData?.[0]?.adsStoreNumber;
        const proposedChangesForStore = proposedChangeMap.get(adsStoreNumber);
        // Patch Proposed Changes File UUIDS
        try {
            if (localResp && locationId && proposedChangesForStore) {
                await apiUpdateProposedEnrollmentFileChanges(locationId, proposedChangesForStore.changeId);
                (0, utils_1.toastSuccess)(`Successfully synced documents with changes`, 3000);
                // Reload location data
                if (locationId) {
                    await getProposedEnrollmentDataChanges(locationId);
                }
            }
        }
        catch (error) {
            (0, utils_1.toastError)(`Failed to sync files and changes`, 5000);
        }
    }, [localResp]);
    // Memo
    const currentData = (0, react_1.useMemo)(() => {
        return state && state.storeInfo
            ? state.storeInfo
            : locationData
                ? locationData
                : [];
    }, [locationData, state]);
    // Func
    const requiresDocUpload = (proposedChangeMap) => {
        const listOfProposedChanges = proposedChangeMap.filter((itm) => itm.needsBankingFileUpload || itm.needsEntityFileUpload);
        return listOfProposedChanges.length > 0;
    };
    // FXs
    (0, react_1.useEffect)(() => {
        createProposedChangesMap(currentData);
    }, [currentData]);
    const handleProposedChangesLoad = (0, react_1.useCallback)(async () => {
        if (proposedChangeMap.size > 0) {
            const displayDataStructure = (0, utils_2.createDataStructure)(proposedChangeMap, currentData);
            for (let i = 0; i < displayDataStructure.length; i++) {
                const data = displayDataStructure[i];
                const currentLocationProposedChanges = proposedChangeMap.get(data.storeNumber);
                const needsFileUploadRes = (0, utils_2.needsFileUpload)(data.bankingChanged, data.entityChanged, currentLocationProposedChanges?.files);
                if (currentLocationProposedChanges.status != 'pending_review' &&
                    !(needsFileUploadRes?.needsBankingFileUpload ||
                        needsFileUploadRes?.needsEntityFileUpload)) {
                    await apiSetPendingReview(data.storeNumber, data.locationId);
                }
            }
            if (displayDataStructure && displayDataStructure.length > 0) {
                setDisplayInfo(displayDataStructure);
                // IMPORTANT
                // Control File Upload Display
                const needsUpload = requiresDocUpload(displayDataStructure);
                setNoDocsNeeded(!needsUpload);
            }
            else {
                setNoDocsNeeded(true);
            }
        }
        else {
            setDisplayInfo([]);
        }
    }, [proposedChangeMap]);
    (0, react_1.useEffect)(() => {
        handleProposedChangesLoad();
    }, [proposedChangeMap]);
    (0, react_1.useEffect)(() => {
        if (localDisplayCont === 'continue') {
            handleContinueCallback();
            setLocalDisplayCont(undefined);
        }
        if (localDisplayCont === 'finish') {
            handleFinishUploadCallback();
            setLocalDisplayCont(undefined);
        }
    }, [localDisplayCont]);
    if (loadingProposedChanges) {
        return (0, jsx_runtime_1.jsx)(components_1.Spinner, {});
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(UploadMsg_1.default, { displayInfo: displayInfo, pageTitle: pageTitle, noDocsNeeded: noDocsNeeded }), (0, jsx_runtime_1.jsx)(UploadForm_1.default, { noDocsNeeded: noDocsNeeded, displayInfo: displayInfo, uploadCallback: handleUploadCallback }), (0, jsx_runtime_1.jsx)(UploadNav_1.default, { displayBasicBtns: displayBasicBtns, noDocsNeeded: noDocsNeeded, displayInfo: displayInfo, pageTitle: pageTitle, handleCallback: handleReturnToDashboard, displayContinue: localDisplayCont, continueCallback: handleContinueCallback, submitting: submitting, returningToDashboard: returningToDashboard })] }));
}
function mapStateToProps(state) {
    return {
        currentLocation: merchant_portal_reducer_1.selectors.currentLocation(state),
    };
}
const mapApiAuthToProps = {
    updateProposedEnrollmentDataChanges: apiActions.updateProposedEnrollmentDataChanges,
    updateProposedEnrollmentFileChanges: apiActions.updateProposedEnrollmentFileChanges,
    getProposedEnrollmentDataChanges: apiActions.getProposedEnrollmentDataChanges,
    fetchAllLocationsForManager: apiActions.fetchAllLocationsForManager,
    fetchLocationDetails: apiActions.fetchLocationDetails,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(DocUpload);
